<template>

	<div class="kucuntihuo">

        <div class="topBar">
                    <div class="daohang">
                            <span @click="tiaozhuan" style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' ">
                            <Icon type="ios-home"></Icon>{{languages.shouye}}</span>>
                            <span style="cursor: pointer; font-size:20px;font-family:'微软雅黑'">{{languages.tihuoshenqing}}</span>
                        </div>
            <div class="iptc">
                <div class="iptlis">
                                <Icon type="ios-search" class='ico'></Icon>

                     <input  class="iptli"  :placeholder=languages.chaxunqingdianjiwo type="primary" @click="modal1 = true">
                    <div class="numEve">
                      <div class="numlitter">{{languages.gong}}{{numnum}}{{languages.tiao}}</div></div>
                </div>
            </div>
        </div>
        <modal class="serchlist"  v-model="modal1"
         width="86%" :styles="{top: '60px',left:'100px',background:'red'}">
            <div class="pz">
                <Select :placeholder=languages.qingxuanze plae type="text" v-model="numpinzhong" clearable style="width: 200px">
                    <Option v-for="item in selectDatta" :value="item" :key="item"></Option>
                </Select>
                <span class='pinzhongs'>{{languages.pinzhong}}</span>
            </div>
            <div class="ph">
                <Select :placeholder=languages.qingxuanze plae type="text" filterable v-model="numpaihao" clearable style="width: 200px">
                    <Option v-for="item in shopDatta" :value="item" :key="item"></Option>
                </Select>

                <span class='paihaos'>{{languages.paihao}}</span>
            </div>
            <div class="hou">
                <Input type="text" v-model="numhou" clearable style="width: 200px"></Input>

                <span class='hous'>{{languages.hou}}</span>
            </div>
            <div class="kuan">
                <Input type="text" v-model="numkuan" clearable style="width: 200px"></Input>

                <span class='kuans'>{{languages.kuan}}</span>
            </div>
            <div class="chang">
                <Input type="text" v-model="numchang" clearable style="width: 200px"></Input>

               <span class='changs'>{{languages.chang}}</span>
            </div>
            <div class="ck">
                <Select :placeholder=languages.qingxuanze plae type="text" v-model="numcangku" clearable style="width: 200px">
                    <Option v-for="item in  wareDatta" :value="item" :key="item"></Option>
                </Select>


                <span class='cangkus'>{{languages.cangku}}</span>
            </div>
            <div class="kunb">
                <Input type="text" v-model="numkunbaohao" clearable style="width: 200px"></Input>
                <span class='kunbaohaos'>{{languages.kunbaohao}}</span>
            </div>
            <div class="chxz">
                <Select :placeholder=languages.qingxuanze plae name="" id="" v-model="cunhuo" clearable style="width: 200px">
                    <Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
                <span class='cunhuo'>{{languages.yewuleixing}}</span>
            </div>

             <div class="muj">
                <Input type="text" v-model="nummujuanhao" clearable style="width: 200px"></Input>

                <span class='mujuanhaos'>{{languages.mujuanhao}}</span>
            </div>
            <div slot="footer" style="background-color:rgb(249,249,249);">
                <div class="chaxun" @click='chaxun()'>{{languages.chaxun}}</div>
                <div class="chongzhi" @click='chongzhis()'>{{languages.chongzhi}}</div>
            </div>
         </modal>
    


    <Scroll :on-reach-bottom="handleReachBottom" height="600" :distance-to-edge=[-20,0]>
        
		<div class="productrow">
			<input class="Partiallyproduct"  @click="Tabswitch1(1)" type="button" :value="languages.chengpin" span="12" v-bind:class='{backcol:BackCol}'></input>
			<input class="material" @click="Tabswitch2" type="button" :value="languages.yuanliao" span="12"  v-bind:class='{backcol2:BackCol2}'></input>
		</div>

		<div class="prolist">
				<div class="Partiallyproductlist" v-if="flag1">
					<Table border :columns="part_list" :data="partproduct" @on-selection-change="getNews"></Table>
                    <Col class="demo-spin-col" span="24" v-show="jiazai">
                        <Spin fix>
                            <p>
                                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                                <div>Loading</div>
                            </p>

                        </Spin>
                    </Col>
                <div class="jiazai">
                     
                   <!-- <p class="add_more_data_btn" v-show="moredata">
                      {{languages.jiazaigengduo}}
                    </p> -->
                    <p class="add_more_data_btn" v-show="moredata">
                      {{languages.jiazaiwanbi}}
                    </p>

                </div>
               
				</div>
				<div class="materiallist" v-if="flag2">

					<Table border :columns="mater_list" @on-selection-change="getNews" :data="materia" class='yuanliao'></Table> 
                    <Col class="demo-spin-col" span="24" v-show="jiazai2">
                            <Spin fix>
                                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                                <div>Loading</div>
                            </Spin>
                        </Col>
                    <div class="zaijia" @click='addmeautwo(1)'>
                        
                         <!-- <p class="add_more_data_btn" v-show="moredatas">
                          {{languages.jiazaigengduo}}
                        </p>
 -->                        
                        <p class="add_more_data_btn" v-show="moredatas">
                          {{languages.jiazaiwanbi}}
                        </p>

                    </div>

				</div>
                
        
    <!-- 购物车按钮 -->
        <div class="subplan"  v-show="sub_lit">
           <div class="table" style="margin-bottom:0">
                <p class="tabletitle">{{languages.gouwuche}}<span @click='subplan_list_lit'> <Icon type="ios-close-outline"></Icon>{{languages.guanbi}}</span></p>
                <div class="tablecontant">
                    <div class="tablecontantBot">
                        <!-- <span class="titcon"> </span> -->
                        <span class="titcon" style="width:8%">{{languages.shouhuokehu}}</span>
                        <span class="titcon" style="width:7%">{{languages.cangku}}</span>
                        <span class="titcon" style="width:9%">{{languages.kuwei}}</span>
                        <span class="titcon" style="width:9%">{{languages.kunbaohao}}</span>
                        <span class="titcon" style="width:4%">{{languages.pinzhong}}</span>
                        <span class="titcon" style="width:6%">{{languages.paihao}}</span>
                        <span class="titcon">{{languages.guige}}</span>
                        <span class="titcon"style="width:4%">{{languages.zhongliang}}</span>
                        <span class="titcon">{{languages.neiwaiban}}</span>
                        <span class="titcon" style="width:5%">{{languages.juanjing}}</span>
                        <span class="titcon">{{languages.rukuriqi}}</span>
                        <span class="titcon" style="width:8%">{{languages.mujuankunbaohao}}</span>
                        <span class="titcon">{{languages.mujuanguige}}</span>
                        <span class="titcon" style="width:5%">{{languages.mujuanzhongliang}}</span>
                        <span class="titcon" style="width:3%">{{languages.jianshu}}</span>
                        <span class="titcon" style="width:4%">{{languages.caozuo}}</span>
                    </div>
                    <div v-for='x,index in newCardObj' :key='index'>
                        <div class="tablemain" v-for='y,indexs in x.value.group' :key='indexs'>
                            <!-- <span class="carhou"></span> -->
                             <!-- <span class="carhou">{{y.customerNa}}</span> -->
                            <span class="guige" style="width:8%">{{y.customerName}}</span>
                            <span class="guige" style="width:7%">{{y.warehouseName}}</span>
                            <span class="guige" style="width:9%">{{y.locationName}}</span>
                            <span class="guige" style="width:9%">{{y.serialCode}}</span>
                            <span class="guige" style="width:4%">{{y.categoryCode}}</span>
                            <span class="guige" style="width:6%">{{y.shopsign}}</span>
                            <span class="guige">{{y.specification}}</span>
                            <span class="guige"style="width:4%">{{y.weight}}</span>
                            <span class="guige">{{y.exposedName}}</span>
                            <span class="guige" style="width:5%">{{y.rollPath}}</span>
                            <span class="guige">{{y.stockInDate}}</span>
                            <span class="guige" style="width:8%">{{y.reelNo}}</span>
                            <span class="guige">{{y.rawPieceSpecdesc}}</span>
                            <span class="guige" style="width:5%">{{y.rawPrimaryQty}}</span>
                            <span class="guige"style="width:3%">{{y.secondQty}}</span>
                            <!-- <span class="guige">{{y.serialCodes}}</span> -->
                            <!-- <span class="zhong">{{y.weight}}</span> -->
                            <span class="caozuo" style="width:4%" @click=removeCarNews(y.serialCode)><Icon type="ios-undo"></Icon></span>
                        </div>

                        <div class="tablemains">
                            <span class="carhous" style="width:26%">{{x.key}}</span>
                            <!-- <span class="guiges">合计</span> -->
                            <span class="zhongs" style="width:24%">{{languages.cangkuheji}}：{{x.value.sum}}</span>
                            <span class="zhongs" style="width:12%">{{languages.kunbaoshuliang}}</span>
                            <span class="caozuos" style="width:12%;border-left: 1px solid #ddd">{{x.value.serialNumber}}</span>
                            <span class="zhongs"style="width:12%">{{languages.shuliang}}</span>
                            <span class="caozuos" style="width:13%;border-left: 1px solid #ddd">{{x.value.number}}</span>
                            <span class="caozuos"></span>
                        </div>
                    
                    </div>
                    <div class="tablemainadd">
                        <span class="tablemainadds">{{languages.heji}}</span>
                        <span class="tablemainadds">{{addnum2.sum}}</span>
                    </div>

                </div>
           </div>
            <div class="tijiaoanniu">
                <button @click="addTitleshow(1)" class="tijiaoButton"><Icon type="ios-cloud-upload"></Icon>{{languages.tijiao}}</button>
                <button @click="reset(newCardObj)" class="tijiaoButton"><Icon type="ios-trash"></Icon>{{languages.qingkong}}</button>
            </div>
        </div>



<!-- 提货计划按钮 -->

        <div class="subplan"  v-show="sub_lit2">
            <div class="table" style="margin-bottom:0">
                <p class="tabletitle">{{languages.tihuojihua}}<span @click='tihuoJihua'> <Icon type="ios-close-outline"></Icon>{{languages.guanbi}}</span></p>
                <div class="tablecontant">
                    <div class="tablecontantBot">
                        <!-- <span class="titcon"> </span> -->
                        <span class="titcon">{{languages.shouhuokehu}}</span>
                        <span class="titcon" style="width:4%">{{languages.cangku}}</span>
                        <span class="titcon" style="width:4%">{{languages.kuwei}}</span>
                        <span class="titcon" style="width:9%">{{languages.kunbaohao}}</span>
                        <span class="titcon" style="width:4%">{{languages.pinzhong}}</span>
                        <span class="titcon" style="width:8%">{{languages.paihao}}</span>
                        <span class="titcon">{{languages.guige}}</span>
                        <span class="titcon" style="width:4%">{{languages.zhongliang}}</span>
                        <span class="titcon">{{languages.neiwaiban}}</span>
                        <span class="titcon" style="width:5%">{{languages.juanjing}}</span>
                        <span class="titcon">{{languages.rukuriqi}}</span>
                        <span class="titcon" style="width:8%">{{languages.mujuankunbaohao}}</span>
                        <span class="titcon">{{languages.mujuanguige}}</span>
                        <span class="titcon">{{languages.mujuanzhongliang}}</span>
                        <span class="titcon" style="width:5%">{{languages.jianshu}}</span>

                        <span class="titcon">{{languages.caozuo}}</span>
                        <!-- <span class="titcon">操作</span> -->
                    </div>
                    <div v-for='x,index in newCardObj2' :key='index'>
                        <div class="tablemain" v-for='y,indexs in x.value.group' :key='indexs'>
                            <span class="guige">{{y.customerName}}</span>

                            <span class="guige" style="width:4%">{{y.warehouseName}}</span>
                            <span class="guige" style="width:4%">{{y.locationName}}</span>
                            <span class="guige" style="width:9%">{{y.serialCode}}</span>
                            <span class="guige" style="width:4%">{{y.categoryCode}}</span>
                            <span class="guige" style="width:8%">{{y.shopsign}}</span>
                            <span class="guige">{{y.specification}}</span>
                            <span class="guige" style="width:4%">{{y.weight}}</span>
                            <span class="guige">{{y.exposedName}}</span>
                            <span class="guige" style="width:5%">{{y.rollPath}}</span>
                            <span class="guige">{{y.stockInDate}}</span>
                            <span class="guige" style="width:8%">{{y.reelNo}}</span>
                            <span class="guige">{{y.rawPieceSpecdesc}}</span>
                            <span class="guige">{{y.rawPrimaryQty}}</span>
                            <span class="guige"style="width:5%">{{y.secondQty}}</span>

                            <!-- <span class="guige">{{y.serialCodes}}</span> -->
                            <!-- <span class="zhong">{{y.weight}}</span> -->
                            <span class="caozuo" @click=removeCarNewss(y.serialCode)><Icon type="ios-undo"></Icon></span>
                        </div>
                        <div class="tablemains">
                            <span class="carhous" style="width:25%">{{x.key}}</span>
                            <!-- <span class="guiges">合计</span> -->
                            <span class="zhongs" style="width:25%">{{languages.cangkuheji}}：{{x.value.sum}}</span>
                            <span class="zhongs" style="width:12%">{{languages.kunbaoshuliang}}</span>
                            <span class="caozuos" style="width:12%;border-left: 1px solid #ddd">{{x.value.serialNumber}}</span>
                            <span class="zhongs"style="width:14%">{{languages.shuliang}}</span>
                            <span class="caozuos" style="width:12%;border-left: 1px solid #ddd">{{x.value.number}}</span>
                        </div>
                    </div>
                    <div class="tablemainadd">
                        <span class="tablemainadds">{{languages.heji}}</span>
                        <span class="tablemainadds">{{addnum3.sum}}</span>
                        <!-- <span class="tablemainadds">捆包数量</span>
                        <span class="tablemainadds">{{addnum3.serialNumber}}</span>
                        <span class="tablemainadds">数量</span>
                        <span class="tablemainadds">{{Number}}</span> -->
                    </div>

                </div>
           </div>
            <div class="tijiaoanniu">  
                <button @click="addTit" class="tijiaoButton"><Icon type="ios-cloud-upload"></Icon>{{languages.tijiao}}</button>
                <button @click="resets(newCardObj2)" class="tijiaoButton"><Icon type="ios-trash"></Icon>{{languages.qingkong}}</button>

            </div>

        </div>
	<div class="bootBanner">
		
    <!-- <button@click='warehouseNameDrop()'>11111</button> -->


		<!-- 提货计划按钮 -->
        
            <p class="liang">
                <span>
                    <span  @click="tihuoJihua" class="tihuoButton"><Icon type="calendar"></Icon>{{languages.tihuojihua}}</span>
                </span>
                <span>
                    <span @click="subplan_list_lit" class="shopButton"><Icon type="ios-cart"></Icon>{{languages.gouwuche}}</span>
                </span>
            </p>
	</div>
		</div>
</Scroll>

		
		<!-- 购物车主信息 -->
		<div class="showTabSecout">
            <transition name='slide-fade'>
			<div class="subpage" v-show="showTabSec">
				<p class="titlefirst">
					<span class="return" @click="fanhui">{{languages.fanhui}}</span>
					<span class="returntitle">{{languages.tihuoshenqing}}</span>
				</p>
				<div class="titSecond">
					<Row class="iptSerch">
                        <Col span="6" class="ipt1">
                            <input type="text" v-model='chengyunshang'>
                            <span class="cys">{{languages.chengyunshang}}</span>
                        </Col>
                        <Col span="6" class="ipt1">
                            <input type="text" v-model='chepaihao'>
                            <span class="cph">{{languages.chepaihao}}</span>
                        </Col>
                        <Col span="6" class="ipt1">
                            <input type="text" v-model='beizhu'>
                            <span class="bz">{{languages.beizhu}}</span>
                        </Col>
                        <Col span="6" class="ipt1">
                            <p>{{languages.shenqingriqi}}：{{this.newDate}}</p>
                        </Col>
                    </Row>
                <Table border :columns="columnsgouwuche" :data="data1" style=""></Table>
                    <div v-for='x,index in newCardObj' :key='index'>
                        <p class="tableP">
                            <div class="tableadd">
                                <span class="guiges">{{languages.hejizongzhongliang}}：</span>
                                <span class="carhous">{{languages.cangku}}:{{x.key}}</span>
                                <span class="zhongs"><p>{{x.value.sum}}</p>吨</span>
                                <span class="caozuos"></span>
                            </div>
                        </p>
                            
                        
                     </div>
				</div>
				<p class="tjthsqan"><span @click='gouwuchequanbus()'>{{languages.tijiao}}</span></p>
			</div>
            </transition>
		</div>

		<!-- 提货申请主信息 -->


        <div class="showTabSecout">
            <transition name='slide-fade'>
            	<div class="subpage" v-show="showTabSectim">
            		<p class="titlefirst">
                        <span class="return" @click="fanhui"><Icon type="reply"></Icon>{{languages.fanhui}}</span>
            		</p>
                    <div class="titSecond" style="position: relative;">
                    	<div class="titleSecs" style="font-size: 25px;color: black;height: 80px; position: absolute;left: 50%;margin-left:-50px;top:-100px;border-top: none;">{{languages.tihuojihua}}</div>     
                    <!--     					<div class="subMinFis">
                    		<div class="titleSec">提货申请子信息</div>
                    	</div> -->
                    <Table border :columns="columns1" :data="subplanNumJihua"></Table>
                    <p class="tableP">
                        <div v-for='x,index in newCardObj2' :key='index'>
                            <div class="tableadd">
                                <span class="carhous">{{x.key}}</span>
                                <span class="guiges">{{languages.heji}}</span>
                                <span class="zhongs">{{x.value.sum}}</span>
                                <span class="caozuos"></span>
                            </div>
                        </div>
                    </p>
                    </div>
                    <p class="tjthsqan"><span @click='tjthsqanspa()'>{{languages.tijiao}}</span></p>
                    
            	</div>
            </transition>
        </div>




<!-- 提货主信息 -->


        <!-- 提货2主信息 -->

	</div>

</template>
<style scoped>
    .ivu-modal-wrap{
        z-index: 10000;
    }
    .serchlist select{
    width:180px;
    height: 40px;
    border-radius: 5px;
    border:1px solid #dddddd;

    }
    .prolist{
        margin-bottom: 100px;
    }
    .ivu-modal-mask{
        width:1px;
        background-color:#e32032  !important;
    }
    .chaxun,.chongzhi{
    width:120px;
    height: 40px;
    background-color:#1d92be;
    border-radius: 10px;
    text-align: center;
    line-height: 40px;
    color: #f5f5f5;
    /*margin-top: 40px;*/
    display: inline-block;
    margin-right: 350px;
}
.serchlist input{
        width:180px;
        height: 35px;
        /*margin-top:30px;*/
        text-align: center;
        border:1px solid #ccc;
        border-radius:5px;
    }
    .serchlist span{
        width:50px;
        height: 20px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        background-color: white;
    }
    .serchlist .pz span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .pz,.ph,.hou,.kuan,.chang,.ck,.kunb,.muj,.chxz,.chanpinyuanliao{
    position: relative;
    /*float: left;*/
    margin-left: 90px;
    margin-top: 20px;
    display: inline-block;
}
.serchlist .chanpinyuanliao span{
    position: absolute;
    left: 10px;
    top:-15px;
} 
.serchlist .ph span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .hou span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .kuan span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .chang span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .ck span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .kunb span{
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .muj span{
    width: 80px;
    position: absolute;
    left: 10px;
    top:-15px;
}
.serchlist .chxz span{
        position: absolute;
    left: 10px;
    top:-18px;
    height: 20px;
}
/*.subpage .titSecond .ivu-table{
    height: 500px;
    overflow-y: scroll !important;
}*/
    .tableP{
        width:100%;
        background-color: #e5ebf2;
        height: 50px;
        /*display: block;*/
    }
    .tableadd{
        min-width: 40%;
        height: 50px;
        background-color:#e5ebf2;
        width:30%;
        margin-top:-60px;
    }
    .tableadd span{
        width:30%;
        font-size: 14px;
        display: inline-block;  
        line-height: 50px;
        border:none;
        text-align:center;
    }
    .tableadd .zhongs p{
        color: red;
        display: inline-block;
    }
    .subplan .table{
            width: 100%;
    max-width: 100%;
    height: 250px;
    min-height: 250px;
    max-height: 300px;
    overflow-y: scroll;
    }
    .numlitter{
      margin-right: 20px;
    }
        .iptlis{
      position: relative;
    }
    .iptlis .ico{
      position: absolute;
      right: 288px;
      top:23px;
      z-index: 7; 
    }
        .kucuntihuo .daohang{
          margin-left: 20px;
          margin-top:10px;
        }
        .kucuntihuo {
            /*overflow: hidden;*/
        }
    .tablemains .carhous{
        /*border-top:1px solid black;*/
        /*border-bottom:1px solid black;*/
        /*border-right: 1px solid #ccc;*/
        /*height: 30px;*/
    }
    .tablemainadd{
        border-top:1px solid #ddd;
        border-bottom:1px solid #ddd;
        overflow:hidden;
        max-width:100%;
        /*width:1289px;*/
    }
    .tablemainadd .tablemainadds{
            border-right: 1px solid #ddd;
            width:50%;
            height: 40px;
            line-height: 40px;
            text-align:center;
            float: left;
        }
    .colspa {
        /*width:25%;*/
        /*display: block;*/
        height: 30px;
        /*display: inline-block;*/
        /*display: inline-block;*/
    }
    .zhongs{
        border-left: 1px solid #ddd;
        height: 30px;
    }
    .tablemain{
        overflow: hidden;

    }
    .tablemains{
        overflow: hidden;
        border-right: 1px solid #ddd;
        border-top:  1px solid #ddd;
        width:100%;
    }
    .tablemain .caozuo{
        color: red;
        font-size: 15px;
        height: 30px;
        width:7%;
        /*line-height: 20px;*/

    }
    .tablemains .guiges{
        width:50%;
        display: inline-block;
        /*border-right: 1px solid #ddd;*/
        border-left:  1px solid #ddd;

        /*height: 30px;*/
    }
    .tablemain .carhou{
        border-top: 1px solid #ddd;
    }
    .tablemains span{
        width:16%;
        line-height: 30px;
        /*border-top:1px solid #ddd;*/
        /*border:1px solid black;*/
        /*border-right: 1px solid black;*/
        /*display: inline-block;*/
        text-align:center;
        float: left;
    }
    .tablemain span{
        width:7%;
        /*border:1px solid black;*/
        border-right: 1px solid #ddd;
        border-top: 1px solid #ddd;
        line-height: 30px;
        /*display: inline-block;*/

        height: 30px;
        text-align:center;
        float: left;
    }
    .tabletitle{
        height: 40px;
        line-height: 50px;
        /*color: #ccc;*/
        text-align:center;
        color: rgb(45,140,240);
        /*font-weight: bold;*/
        font-size: 25px;
        position: relative;
        /*overflow:hidden;*/
    }
    .tabletitle span{
        position: absolute;
        right: 30px;
        color: black;
        font-size:15px;
        /*float:right;*/
        /*margin-right:50px;*/
        /*display: inline-block;*/
    }
    .tabletitle span .ivu-icon{
        font-size:20px;
        /*line-height: 40px;*/
    }
    .tablecontantBot{
        overflow: hidden;
    }
/*        .tablecontantBot .guige{
        height: 50px;
    }*/
    .tablecontantBot .titcon{
        width:7%;
        display: inline-block;
        height: 30px;
        text-align: center;
        line-height: 30px;
        /*height: 100%;*/
        float:left;
        border-right: 1px solid #ddd;
        border-top:1px solid #ddd;
    }

    /*.subplan tr button{
        border:none;
        width:100%;
        height:100%;
        color:#1d92be;
        font-size: 25px;
        background-color:white;
    }*/
       .numEve{
            position: absolute;
            right: 61px;
            top:15px;
            line-height: 30px;
            background-color:#ffffff;
            height: 30px;
            width: 250px;
            text-align: right;
            color: #0066ff;
        }
        .topBar{
        position: relative;
        }
        .daohang{
        position: absolute;
        top:10px;
        left: 10px;
        z-index: 8;
        }
        .down{
        width:30px;
        height:30px;
        position:absolute;
        top:15px;
        right:40px;
        font-size: 45px;
        /*background-color:#fff;*/
        }
       
            .iptli{
            width:140px;
            height: 24px; 
            border:none;
            position: absolute;
            right: 168px;
            top:18px;
            cursor: pointer;
            background-color: #eaeaea;
            padding-left:30px;
            /*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
            /*text-align:left;*/
            border-radius: 3px;
            z-index: 6;
            /*border-shadow:3px 6px;*/
            /*position: relative;*/
        }

        .iptc{
            height: 65px;
            background:url(../assets/header.gif)repeat-x 0 0px;
            background-color: #cdd9e8;
            border-color: #8ba0bc;
            position: relative;
            /*background:url(../assets/one.jpg);*/
        }
       
        

        .ipt1{
        position: relative;
        top:40px;
        left: 20px;
        /*cursor:pointer;*/
        }
        .ipt1 .cys,.cph{
        /*border:1px solid #ccc;*/
        width:60px;
        display: inline-block;
        position: absolute;
        left:40px;
        background-color:#f9f9f9;
        top:-15px;
        text-align: center;
        }
/*        .ipt1 .cph{
        width:50px;
        display: inline-block;
        position: absolute;
        left:40px;
        background-color:#f9f9f9;
        top:-15px;
        text-align: center;
        }*/
        .ipt1 input{
        text-align: center;
        background-color:#f9f9f9;
        border:1px solid #ccc;
        height: 30px;
        width:200px;
        margin-left: 30px;  
        cursor:pointer;
        }
        .ipt1 .bz{
        /*border:1px solid #ccc;*/
        width:40px;
        display: inline-block;
        position: absolute;
        left:40px;
        background-color:#f9f9f9;
        top:-15px;
        text-align: center;
        }
        .iptserch span{
        background-color:red;
        display: block;
        }
        .tjthsqan{
        text-align: center;
        /*line-height: 200px;*/
        height: 300px;
        margin-bottom: 100px;
        }
        .tjthsqan span{
        width:150px;
        text-align: center; 
        line-height: 60px;
        margin:0 auto;
        display: inline-block;
        color: white;
        height: 60px;
        margin-bottom:80px;
        border-radius: 10px;
        background-color:#1d92be;
        }
        .slide-fade-enter-active {
        transition: all .5s;
        }
        .slide-fade-leave-active {
        transition: all .5s;
        }
        .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
        transform: translateX(100%);
        opacity: 1;
        }
        .classtit{
        height: 30px;
        position: relative;
        top:0;
        /*left:10px;*/
        /*line-height: 30px;*/
        /*border-bottom: 1px solid #2d8cf0;*/
        }
    /*    .classtit div{
        color:#2d8cf0;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-bottom:2px solid #2d8cf0;
        width:100px;
        }*/
        .jiazai{
        text-align: center; 
        cursor: pointer;
        p{
            text-align: center;
        }
        /*text-align: center;*/
        /*padding-top:20px;*/
        }
        .zaijia{
        text-align: center; 
        cursor: pointer;
        padding-top:20px;
        }
        .Partiallyproductlist .ivu-table-wrapper{
        border:none;
        }
        .tijiaoanniu{
        width: 100%;
        height: 60px;
        background-color:#e5ebf2;
        }
        .subplan{
        position: fixed;
        width: 85% !important;
        /*height: 100%;*/
        right:0px;
        bottom: 75px;
        border: 1px solid #ddd;	
        z-index: 9;
        background-color:white;
        /*margin-bottom:30px;*/
        }
      /*  .subplan tr{
            text-align:center;
        }*/
        .bootBanner{
            overflow:hidden;
            min-width:100%;
            margin-top:100px;
            position: fixed;
            bottom:-5px;
            margin-top:30px;
            z-index: 8;
            overflow:hidden;
            /*margin-top:50px;*/
            /*padding-top:0px;*/
        }
        .bootBanner span span{
        float: right;
        width:170px;
        height:80px;
        line-height: 80px;
        border: 1px solid #ccc;
        text-align:center;
        background-color:#1d92be;
        cursor:pointer;
        font-size: 18px;
        margin-right: 5px;
        display: block;
        }
        /*.boo*/
        .bootBanner .ivu-icon{
            margin-right:5px;
            color: #ffffff;
            font-size: 20px;
        }
        .bootBanner .liang{
        background-color:#e5ebf2;
        display: block;
        /*width: %;*/
        height: 80px;
        margin-right:200px;
        z-index: 1000 !important;
        /*position: fixed;*/
        /*bottom: -10px;*/
        /*margin-right: 20px;*/
        
        }
        .tijiaoButton{
        float:right;
        /*margin-top: -15px;*/
        border: none;
        border-radius: 10px;
        height: 46px;
        width: 100px;
        background-color:#1d92be;
        margin-top: 8px;
        margin-right: 20px;
        color: white;
        font-size:18px;
        font-style:  normal;
        z-index: 155;
        }
        .tijiaoButton .ivu-icon{
            margin-right:7px;
            color: #ffffff;

        }
        .showTabSecout{
        position: absolute;
        top:0;
        left: 0px;
        /*bottom: 0px;*/
        width:100%;
        /*height: 100%;*/
        /*background-color:white;*/
        /*z-index: 1111;*/

        /*height: 1000px;*/
        /*z-index: 120;*/
        }
        .productrow{
        /*overflow: hidden;	*/

        width:100%;
        height: 40px;

        }
        .productrow input{
        border:1px solid #ccc;
        color:#d3d3d3;
        width: 50%;
        float: left;
        height:40px;
        font-weight: bold;	
        background-color:#f2f2f2;
        }
        .button_plan{
        background-color:green;
        width:20%;
        height:5%;
        text-align: center;
        line-height: 50px;
        cursor:pointer;
        margin-right: 60px;
        }
        .liang span{
        color: white;
        font-size:17px;
        /*display: block;*/
        /*display: block;*/
        }

        .sub_add{
        width: 100%;
        background-color:white;
        z-index: 10;
        height:40px;
        /*text-align: center;*/
        line-height: 40px;
        border:1px solid #ccc;
        }
        .subpage .ivu-table-wrapper{
        border:none;

        /*overflow: scroll;*/
        }
        .titlefirst{
        border-bottom:1px solid #ccc;
        height: 63px;
        /*position: fixed;*/
        }
        .return{
        height: 62px;
        width: 125px;
        display: block;
        background-color:#1d92be;
        line-height: 60px;
        text-align: center;
        color: white;
        font-size: 18px;
        cursor:pointer;
        z-index:11111;
        /*pointer:;*/
        }
        .returntitle{
        display:block;
        margin:0 auto;
        width:800px;
        cursor:pointer;
        text-align: center;
        font-size: 23px;
        margin-top:-35px;
        }
        .subpage{
        width: 100%;
        min-height: 100%;
        /*max-height: 200%;*/
        min-width: 900px;
        height: 800px;
        position: fixed;
        left: 50px;
        /*top:-30px;*/
        background-color:white;
        overflow-y: scroll;
        /*margin-top: -700px;*/
        /*background-color:red;*/
        z-index: 11;
        }
        .titSecond .titleSec{
        text-align: center;
        /*border-top:2px solid #cccccc;*/
        font-size:20px;
        height: 30px;
        width:200px;
        position: absolute;
        top:-15px;
        left:50%;
        margin-left: -100px;
        z-index: 10;
        background-color: white;
        }
        .subMinFis .titleSec{
        font-size: 15px;
        height: 100px;
        line-height: 100px;
        }
        .titSecond{
        width:95%;
        position: relative;
        /*margin-top: 50px;*/
        /*border-top: 2px solid #ccc;*/
        margin:60px auto;
        }
        .iptSerch{
        height:100px !important;
        display: block;
        background-color:#f9f9f9;
        margin-bottom: 40px;

        }
        .materiallist .ivu-table-wrapper{
        border:none;
        }
        .backcol{
        background-color:white !important;
        color: #1089f5 !important;
        border-bottom: 2px solid #1089f5 !important;
        z-index: 10;
        /*border-color: blue;*/
        /*border:none;*/
        /*border-left:  3px solid #1089f5 !important;*/
        /*border-right:  3px solid #1089f5 !important;*/
        }
        .backcol2{

        background-color:white !important;
        color: #1089f5 !important;
        border-bottom: 2px solid #1089f5 !important;
        z-index: 10;

        /*border:3px solid #b8d6f1 !important;*/
        }
        .Partiallyproductlist, .ivu-table-header, .ivu-table th{
            background-color:#e9eaec !important;
        }
            .add_more_data_btn{
    width:120px;
    /*height:40px;*/
    line-height:40px;
    margin:0 auto;
    /*position: absolute;*/
    /*top: 580px;*/
    /*left:50%;*/
    /*transform: translateX(-50%);*/
    text-align:center;
    cursor:pointer;
    }
    .add_more_data_btn:hover{
    color:#2d8cf0;
    }
/*        .add_more_data_btn{
        width:100px;
        height:40px;
        line-height:80px;
        position: absolute;
        top: 5px;
        left:50%;
        transform: translateX(-50%);
        text-align:center;
        cursor:pointer;
    }
    .add_more_data_btn:hover{
       color:#2d8cf0;
    }*/
       
</style>
<script>
import axios from 'axios'
import config from 'config/apiConfig'
import language from 'api/language.js'
  export default {
    name:'index',
    data () {
    	
      return {
        languages:{},
        modal1:false,
        newCardObj:[],
        newCardObj2:[],
        addnum:[],
        addnum2:[],
        addnum3:[],
        // carsehouse:[],
      	flag1:false,
      	flag2:true,
        data1:[],
      	data2:[],
      	partproduct:[],
      	partproductSec:[],
      	materia:[],
        subplan_num:[],
      	subplan_numlit:[],
      	active:"blue",
      	sub_lit:false,
      	sub_lit2:false,
      	returna:true,
      	// sub_lit:!sub_lit2,
        subplanNumJihua:[],
      	// subplanNumJihuas:[],
      	showTabSec:false,
        showTab:false,
        showTabs:false,
      	showTabSectim:false,
        // backgroundColor:'red',
        // color:'green',
        totalPageCount:'',
        // totalPageCount2:'',
        resgouwuche:0,
        resgouwuche2:0,
        // newgouwuche:0,
        BackCol:false,
        BackCol2:false,
        chengyunshang:'',
        chepaihao:'',
        beizhu:'',
        // sousuo:'',
        chengyunshang1:'',
        // chepaihao1:'',
        // beizhu1:'',
        numpinzhong:'',
        numpaihao:'',
        numhou:'',
        numchang:'',
        numkuan:'',
        numcangku:'',
        numkunbaohao:'',
        nummujuanhao:'',
        cunhuo:'',
        // cpyl:'',
        numnum:'',
        // orderNum:'',
        // packNumK:'',
        // prodCode:'',
        // data3:[],
        // packnum:[],
        weightres:0,
        newDate:'',
        indexnum:'',
        selectDatta:[],
        shopDatta:[],
        wareDatta:[],
        moredata:false,
        moredatas:false,
        jiazai:false,
        jiazai2:false,
          cityList: [
                    {
                        value: 'LLIN',
                        label: language.lailiaojiagong,
                    },
                    {
                        value: 'CCIN',
                        label: language.cangchu,
                    },
                    {
                        value: 'PSIN',
                        label: language.peisong,
                    },
                    {
                        value: 'QTIN',
                        label: language.qita,
                    },
                    
                ],
      		part_list: [
                    // { 
                    //     title: '',
                    //     key: '',
                    //     type:'selection',
                    //     align:'center',
                    //     minWidth:50,
                    //     width:50,
                    //     render: (h, params) => {
                    //         return h('div', [
                    //             h('Button', {
                    //             },
                    //             [h('selection',{
                    //                 props:{
                    //                     type:'checkmark-round'
                    //                 }
                    //             })]
                    //             ),
                                                               
                    //             h('strong', params.row.name)
                    //         ],

                    //         );
                    //     }
                    // },
                   
                    {
                        title: language.caozuo,
                        // key: 'name',
                        align:'center',
                        minWidth:50,
                        minWidth:50,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    on:{
                                    	click:()=>{
                                    		this.subCat(params)
                                            // this.subp();
                                    	}
                                    },
                                    style:{
                                        border:'1px solid white',
                                        backgroundColor:'white'
                                    }
                                },
                                [h('icon',{
                                	props:{
                                		type:'ios-cart'
                                	},
                                    style:{
                                        fontSize:'14px',
                                        // color:''
                                    }
                                })]
                                ),
								                               
                                h('strong', params.row.name)
                            ],

                            );
                        }
                    },
                    {
                        title: language.shouhuokehu,
                        key: 'customerName',  
                        minWidth:80,  
                        minWidth:120,
                        align:'center'
                    },
                    {
                        title: language.cangku,
                        align:'center',
                        minWidth:60, 
                        key: 'warehouseName'
                    },
                    {
                        title: language.kuwei,
                        align:'center',
                        minWidth:60, 
                        key: 'locationName'
                    },
                    {
                        title: language.kunbaohao,
                        minWidth:100,
                        minWidth:100,
                        align:'center',
                        key: 'serialCode'
                    },
                    {
                        title: language.pinzhong,
                        minWidth:60,
                        minWidth:60,
                        align:'center',
                        key: 'categoryCode'
                    },
                    {
                        title: language.paihao,
                        key: 'shopsign',
                        minWidth:120,
                        align:'center',
                        // minWidth:110
                    },
                    {
                        title: language.guige,
                        align:'center',
                        // minWidth:100,
                        minWidth:90,
                        key: 'specification'
                    },
                    {
                        title: language.zhongliang,
                        minWidth:60,
                        minWidth:60,
                        align:'center',
                        key: 'primaryQty'
                    },
                    {
                        title: language.shuliang,
                        minWidth:60,
                        minWidth:60,
                        align:'center',
                        key: 'secondQty'
                    },
                    {
                        title: language.neiwaiban,
                        minWidth:80,
                        align:'center',
                        key: 'exposedName'
                    },
                    {
                        title: language.duxinceng,
                        key: 'extCol12',
                        align:'center',
                        minWidth:90
                      },
                    {
                        title: language.juanjing,
                        // minWidth:70,
                        minWidth:70,
                        align:'center',
                        key: 'rollPath'
                    },
                    {
                        title: language.rukuriqi,
                        // minWidth:80,
                        minWidth:80,
                        align:'center',
                        key: 'stockInDate'
                    },
                    {
                        title: language.mujuankunbaohao,
                        minWidth:100,
                        align:"center",
                        key: 'reelNo'
                    },

                    {
                        title: language.mujuanguige,
                        key: 'rawPieceSpecdesc',
                        minWidth:80,
                        minWidth:80,
                        align:'center'
                    },
                    {
                        title: language.mujuanzhongliang,
                        key: 'rawPrimaryQty',
                        minWidth:80,
                        minWidth:80,
                        align:'center'
                    },
                    {
                        title: language.yewuleixing,
                        minWidth:100,
                        minWidth:100,
                        // paddingLeft:20,
                        align:'center',
                        key: 'businessTypeName',
                    }
                ],	
                mater_list: [
                	// {
                 //        title: '仓库',
                 //        key: '',
                 //        width:50,
                 //        type:'selection',
                 //        align:'center',
                 //       render: (h, params) => {
                 //            return h('div', [
                 //                h('Button', {
                 //                    on:{
                 //                        'on-change':(event)=>{
                 //                            this.subCat(params)
                 //                            // this.subp()
                 //                        }
                 //                    },
                 //                },
                 //                [h('icon',{
                 //                    props:{
                 //                        type:'ios-cart'
                 //                    }
                 //                })]
                 //                ),
                                                               
                 //                h('strong', params.row.name)
                 //            ],

                 //            );
                 //        }
                 //    },

                    {
                        title: language.caozuo,
                        key: 'name',
                        minWidth:100,   
                        align:'center',
                        // border:'none',
                        render: (h, params) => {
                            return h('div', [
                                   h('Button', {
                                    on:{
                                    	click:()=>{
                                    		this.tijiao(params)
                                    	}
                                    },
                                    style:{
                                        border:'none',
                                        backgroundColor:'white',
                                        // color:'blue',
                                        fontSize:'15px'
                                    }
                                },
                                [h('icon',{
                                	props:{
                                		type:'ios-cart'
                                	},
                                	style:{
                                		// marginLeft:"-10px",
                                		// textAlign:"center"
                                		// lineHeight:"10px"
                                	},
                                })]
                                ),
								 h('Button', {
                                    on:{
                                    	click:()=>{
                                    		this.tiHuoplan(params)
                                    	}
                                    },
                                      style:{
                                        border:'none',
                                        backgroundColor:'white',
                                        // color:'blue',
                                        fontSize:'15px'
                                    },
                                },
                                [h('icon',{
                                	props:{
                                		type:'calendar'
                                	},
                                	style:{
                                        fontSize:16

                                		// marginLeft:"-10px",
                                		// textAlign:"center"
                                	},
                                })]
                                ), 


                                h('strong', params.row.name)
                            ]);
                        }
                    },
                    {
                            title: language.shouhuokehu,
                            minWidth: 120,
                            align:'center',
                            key: 'customerName'
                        },
                    {
                        title: language.cangku,
                        align:'center',
                        minWidth: 80,
                        key: 'warehouseName'
                    },
                    {
                        title: language.kuwei,
                        align:'center',
                        minWidth: 80,
                        key: 'locationName'
                    },
                    {
                            title: language.kunbaohao,
                            align:'center',
                            minWidth: 120,
                            key: 'serialCode'
                        },
	                    {
	                        title: language.pinzhong,
                            align:'center',
                            minWidth: 60,
	                        key: 'categoryCode'
	                    },
	                    {
	                        title: language.paihao,
                            align:'center',
                            minWidth: 110,
	                        key: 'shopsign'
	                    },
	                    {
	                        title: language.guige,
                            align:'center',
                            minWidth: 80,
	                        key: 'specification'
	                    },
	                    
	                    
	                    {
                            title: language.zhongliang,
                            align:'center',
                            minWidth: 60,
                            key: 'primaryQty'
                        },
                        {
	                        title: language.shuliang,
                            align:'center',
                            minWidth: 60,
	                        key: 'secondQty'
	                    },
	                    {
	                        title: language.neiwaiban,
                            align:'center',
                            minWidth: 90,
	                        key: 'exposedName'
	                    },
                        {
                            title: language.duxinceng,
                            key: 'extCol12',
                            align:'center',
                            minWidth:90
                          },
	                    {
	                        title: language.juanjing,
                            align:'center',
                            minWidth: 90,
	                        key: 'rollPath'
	                    },
	                    {
	                        title: language.rukuriqi,
                            align:'center',
                            minWidth: 90,
	                        key: 'stockInDate'
	                    },
                        {
                        title: language.mujuanzhongliang,
                        key: 'rawPrimaryQty',
                        // minminWidth:80,
                        minWidth:80,
                        align:'center'
                        },
	                    {
	                        title: language.yewuleixing,
                            align:'center',
                            // minminWidth:120,
                             minWidth:120,
	                        key: 'businessTypeName',
	                        // width: 150,
                    }

                ],

                columns1: [
                    {
                        title: language.caozuo,
                        align:'center',
                        key: 'address',
                        width:50,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        size: 'small'
                                    },
                                    style:{
                                        border:'none',
                                        backgroundColor:'#fff',
                                        // margin:"0 auto"
                                        fontSize:"20px"
                                    },
                                    on:{
                                        click: ()=>{
                                            this.removeTihuo(params)
                                        }
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: "reply-all"
                                        }
                                    })

                                ])
                            ]);
                        }
                    },
                    {
                        // title: '收货客户',
                        title: language.shouhuokehu,
                        align:'center',
                        key: 'customerName',
                    },
                    {
                        title: language.cangku,
                        // title: '仓库',
                        align:'center',
                        key: 'warehouseName'
                    },
                    {
                        title: language.kuwei,
                        // title: '库位',
                        align:'center',
                        // width: 80,
                        key: 'locationName'
                    },
                    {
                        title: language.kunbaohao,
                        // title: '捆包号',
                        align:'center',
                        key: 'serialCode'
                    },
                     {
                        title: language.pinzhong,
                        // title: '品种',
                        align:'center',
                        width:50,
                        key: 'categoryCode'
                    },
                     {
                        title: language.paihao,
                        // title: '牌号',
                        align:'center',
                        key: 'shopsign'
                    },
                     {
                        title: language.guige,
                        // title: '规格',
                        align:'center',
                        key: 'specification'
                    },
                     
                     
                     {
                        title: language.zhongliang,
                        // title: '重量',
                        align:'center',
                        width:100,
                        key: 'primaryQty'
                    },
                     {
                        title: language.neiwaiban,
                        // title: '内/外版',
                        align:'center',
                        key: 'exposedName'
                    },
                    {
                         // title: '入库日期',
                         title: language.rukuriqi,
                         align:'center',
                        key: 'stockInDate'
                    },
                    {
                        title: language.jiaohuoqi,
                        // title: '交货期',
                        align:'center',
                        key: 'deliveryDate',
                        width: 130,
                        // zIndex:111, 
                        render:(h,params) => {
                            return h('DatePicker',{
                                props:{
                                    type:"date",
                                    value:params.row.deliveryDate
                                },
                                on:{
                                    'on-change':(val)=>{
                                        this.dataChange(params,val)
                                    }
                                }
                            })
                        }
                    },
                    
                ],
                
                columnsgouwuche: [
                {
                        title: language.caozuo,
                        key: 'address',
                        width:85,
                        align:'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        size: 'small'
                                    },
                                    style:{
                                        border:'none',
                                        backgroundColor:'#fff',
                                        // margin:"0 auto"
                                        fontSize:"20px"
                                    },
                                    on:{
                                        click: ()=>{
                                            this.removeCar(params)
                                        }
                                    }
                                },[
                                    h('Icon', {
                                        props: {
                                            type: "reply-all"
                                        }
                                    })

                                ])
                            ]);
                        }
                    },
                    {
                        title: language.shouhuokehu,
                        key: 'customerName',
                        align:'center',
                        width:120
                    },
                    {
                        title: language.cangku,
                        width:65,
                        align:'center',
                        key: 'warehouseName',
                    },
                    {
                        title: language.kuwei,
                        align:'center',
                        width: 80,
                        key: 'locationName'
                    },
                    {
                        title: language.kunbaohao,
                        width:100,
                        align:'center',
                        key: 'serialCode'
                    },
                    {
                        // title: '品种',
                        title: language.pinzhong,
                        width:65,
                        align:'center',
                        key: 'categoryCode'
                    },
                     {
                        title: language.paihao,
                        width:130,
                        align:'center',
                        key: 'shopsign'
                    },
                     {
                        title: language.guige,
                        width:100,
                        align:'center',
                        key: 'specification'
                    },
                    {
                        title: language.zhongliang,
                        key: 'primaryQty',
                        align:'center',
                        width:65,
                    },
                     {
                        title: language.neiwaiban,
                        key: 'exposedName',
                        align:'center',
                        width:75,
                    },
                    // {
                    //     title: '存货性质',
                    //     align:'center',
                    //     width:85,
                    //     key: 'stockType',

                    // },
                     {
                        title: language.mujuanhao,
                        key: 'reelNo',
                        align:'center',
                        width:120,
                    },
                     {
                        title: language.mujuanguige,
                        key: 'rawPieceSpecdesc',
                        align:'center',
                        width:85
                    },
                     {
                        // title: '母卷重量',
                        title: language.mujuanzhongliang,
                        key: 'rawPrimaryQty',
                        align:'center',
                        width:85
                    },
                    
                     
                     
                     
                     
                    {
                        title: language.jiaohuoqi,
                        // title: '交货期',
                        key: 'deliveryDate',
                        align:'center',
                        width:180,
                        // align:"center",
                        // width: 200,
                        // zIndex:111, 
                        render:(h,params) => {
                            return h('DatePicker',{
                                props:{
                                    type:"date",
                                    value:params.row.deliveryDate,
                                },
                                on:{
                                    'on-change':(val)=>{
                                        this.dataChanged(params,val)


                                    }
                                }
                            })
                        }
                    },
                    {
                        title: language.jiesuanyonghu,
                        // title: '结算用户',
                        key: 'settlementUser',
                        align:'center',
                        width:160,
                        render: (h, params) => {  
                            let that = this;
                            // that.x()
                            if(params.row.order){
                                return h('div'
                                )
                            }
                            if(params.row.contractNo||params.row.businessType=='CCIN'||params.row.businessType=='LLIN'){
                                return h('div')
                            } else if(!params.row.templateCode||!params.row.templateSubid){
                                let options = 
                                that.queryClearinguser.map(function(type){  
                                    return h('Option', {  
                                        props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                                        style:{
                                            width:'140px',
                                            overflow:'hidden',
                                        },
                                        attrs: {title: type.label,}
                                    }, type.label);  
                                });  
                            return h('Select', {  
                                props:{  
                                    filterable:true,
                                    labelInValue:true,
                                    value: that.data1[params.index].settlementUser,  
                                    // value: that.data1[params.index].settlementUser,  
                                },
                                // style:{
                                //     // width:"100px",
                                //     textAlign:"center",
                                // },  
                                // attrs:{
                                //     disabled:!params.row.templateCode
                                // },
                                on: {  
                                    'on-change':(value) => { 
                                        that.data1[params.index].settlementUser = value.value;  
                                        that.data1[params.index].settlementUserName = value.label;  

                                    }  
                                },  
                            },
                            [options
                            ]  
                            );  
                            } else if(that.data1[params.index].templateCode&&that.data1[params.index].templateSubid){
                                return h('div',
                                   that.data1[params.index].settlementUserName
                                )
                            }
                            
                        },  
                    },
                    {
                        title: language.jiesuanbizhong,
                        // title: '结算币种',
                        key: 'settlementCurrency',
                        width:100,
                        align:'center',
                        render: (h, params) => {  
                            let that = this;
                            if(params.row.order){
                                return h('div'
                                )
                            }
                            if(params.row.contractNo||params.row.businessType=='CCIN'||params.row.businessType=='LLIN'){
                                return h('div')
                            }
                            else if(!params.row.templateCode||!params.row.templateSubid){
                                let options = 
                                that.settlementCurrency.map(function(type){  
                                    return h('Option', {  
                                        props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                                        
                                        attrs: {title: type.label,}
                                    }, type.label);  
                                });  
                            return h('Select', {  
                                props:{  
                                    filterable:true,
                                    labelInValue:true,
                                    value: that.data1[params.index].settlementCurrency,  
                                },
                                on: {  
                                    'on-change':(value) => { 
                                        that.data1[params.index].settlementCurrency = value.value;  
                                        that.data1[params.index].settlementCurrencyName = value.label;  
                                        console.log(that.data1[params.index])
                                        // console.log(that.data1[params.index])
                                    }  
                                },
                                // attrs:{
                                //     disabled:!params.row.templateCode
                                // },
                            },
                            [options]  
                            ); 
                        }else if(that.data1[params.index].templateCode&&that.data1[params.index].templateSubid){
                            return h('div',that.data1[params.index].settlementCurrencyName)
                        }
                             
                        }, 
                    },
                    {
                        title: language.jiaohuofangshi,
                        // title: '交货方式',
                        key: 'deliveryMethod',
                        width:120,
                        align:'center',
                        render: (h, params) => {  
                            let that = this;
                            if(params.row.order){
                                return h('div'
                                )
                            }
                            if(params.row.contractNo||params.row.businessType=='CCIN'||params.row.businessType=='LLIN'){
                                // console.log(111)
                                return h('div')
                            }
                            else if(!params.row.templateCode||!params.row.templateSubid){
                                let options = 
                                that.deliveryMethod.map(function(type){  
                                    return h('Option', {  
                                        props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                                        style:{
                                            width:'100px',
                                            overflow:'hidden',
                                        },
                                        attrs: {title: type.label}
                                    }, type.label);  
                                });  
                            return h('Select', {  
                                props:{  
                                    filterable:true,
                                    labelInValue:true,
                                    value: that.data1[params.index].deliveryMethod,  
                                },
                                on: {  
                                    'on-change':(value) => { 
                                        that.data1[params.index].deliveryMethod = value.value;  
                                        that.data1[params.index].deliveryMethodName = value.label;  
                                    }  
                                },  
                                // attrs:{
                                //     disabled:!params.row.templateCode
                                // }
                            },
                            [options
                            ]  
                            );  
                        }else if(that.data1[params.index].templateCode&&that.data1[params.index].templateSubid){
                            return h('div',that.data1[params.index].deliveryMethodName)
                            
                        }
                        }
                    },
                    {
                        title: language.jiaohuodi,
                        // title: '交货地',
                        key: 'deliveryPlace',
                        width:200,
                        align:'center',
                        render: (h, params) => {  
                            let that = this;
                            if(params.row.order){
                                return h('div'
                                )
                            }

                            if(params.row.contractNo||params.row.businessType=='CCIN'||params.row.businessType=='LLIN'){
                                return h('div')
                            }
                            else if(!params.row.templateCode||!params.row.templateSubid){
                                let options = 
                                that.deliveryPlace.map(function(type){  
                                    return h('Option', {  
                                        props: {label: type.label == null?'':type.label,value: type.value == null?'':type.value},
                                        style:{
                                            width:'170px',

                                            overflow:'hidden',
                                        },
                                        attrs: {title: type.label}
                                    }, type.label);  
                                });  
                            return h('Select', {  
                                props:{  
                                    filterable:true,
                                    labelInValue:true,
                                    value: that.data1[params.index].deliveryPlaceName,  
                                    label: that.data1[params.index].deliveryPlace,  

                                },
                                on: {  
                                    'on-change':(value) => { 
                                        that.data1[params.index].deliveryPlaceName = value.value;  
                                        that.data1[params.index].deliveryPlace = value.label;  
                                    }  
                                },  
                                // attrs:{
                                //     disabled:!params.row.templateCode
                                // },
                            },
                            [options
                            ]  
                            );  
                        }else if(that.data1[params.index].templateCode&&that.data1[params.index].templateSubid){
                            // console.log(that.data1)
                            return h('div',that.data1[params.index].deliveryPlace)

                        }
                        }
                    },
                    
                ],
               
        }
  },
   methods: {
        handleReachBottom(){
            return new Promise(addmeauhecheng=>{
                
                    let that = this
                    if(that.flag1==true){
                        // let that=this;
                        // that.moredata=false
                // let paramsData={
                //     "productMaterials": "1",
                //     "offset":that.partproduct.length,
                //     "limit":'10',
                //     }
                // if(indexs = 1){

                    let paramsData = {
                    // "productMaterials": "1",
                    "offset":that.partproduct.length,
                    "limit":'10',
                    "categoryCode":that.numpinzhong,
                    "shopsign":that.numpaihao,
                    "thickness":that.numhou,
                    "length":that.numchang,
                    "width":that.numkuan,
                    "warehouseName":that.numcangku,
                    "serialCode":that.numkunbaohao,
                    "categoryCode":that.numpinzhong,
                    "productMaterials":"1",
                    "queryFlag":"02",
                    "businessType" : that.cunhuo,
                    }
                if(that.partproduct.length%10 != 0){ that.moredata=true;that.jiazai=false; return;}
                if(that.totalPageCount%10 == 0 && that.partproduct.length == that.totalPageCount){ that.moredata=true;that.jiazai=false; return;}
                        that.jiazai=true

                axios.post(config.queryStockOnHand,paramsData).then(
                        function(response){  

                            if(response.data.resultCode == 1){
                                that.jiazai=false
                            // that.$Message.info(language.jiazaiwanbi);

                            that.partproduct = that.partproduct.concat(response.data.resultData);
                            // return false
                               // console.log(response.limit)
                            }else{
                                that.$Message.info(language.jiazaishibai)
                            }
                           addmeauhecheng();
                        })
                    return
                // }
                    }else if(that.flag2==true){
                        // let that=this;
                        that.jiazai2=true
                        // that.resl=0;

            // console.log(indexs)
            // let paramsData={
            //     "productMaterials": "2",
            //     "limit":'10',
            //     "offset":that.materia.length,
            //     }
            // if(indexs = 1){

                let  paramsData = {
                // "productMaterials": "2",
                "offset":'10',
                "limit":'10',
                "offset":that.materia.length,
                "categoryCode":that.numpinzhong,
                "shopsign":that.numpaihao,
                "thickness":that.numhou,
                "length":that.numchang,
                "width":that.numkuan,
                "warehouseName":that.numcangku,
                "serialCode":that.numkunbaohao,
                "categoryCode":that.numpinzhong,
                "productMaterials":"2",
                "queryFlag":"02",
                }
              if(that.materia.length%10 != 0){ that.moredatas=true;that.jiazai2=false; return;}
              if(that.totalPageCount%10 == 0 && that.materia.length == that.materia){ that.moredatas=true;that.jiazai2=false; return;}
             that.jiazai2=true;
            axios.post(config.queryStockOnHand,paramsData).then(
                    function(response){  
                        addmeauhecheng();
                        if(response.data.resultCode == 1){
                            that.jiazai2=false
                        that.materia = that.materia.concat(response.data.resultData);
                        that.$Message.info(language.jiazaiwanbi)
                           
                        }else{
                        that.$Message.info(language.jiazaishibai)
                        }
                       
                    })
                return
            // }
                    }
                })
        },
        reset(x){
            let that = this;
            let paramsData=new FormData();
            // let paramsData = new FormData();
            // that.newCardObj='';
            // console.log(that.newCardObj)
            console.log(x)
            let numberser=new Array()
            for(var i=0;i<x[0].value.group.length;i++){
                console.log(x[0].value.group[i].serialCode)
                numberser.push(x[0].value.group[i].serialCode)
            }
            console.log(numberser)
            paramsData.append("serialCode",numberser.toString());

            // paramsData.numberser=
            // paramsData=numberser.toString();
            // paramsData:
            // paramsData.push(numberser);
            // paramsData={
            //     "serialCode":numberser.toString()
            // }
            const instance = axios.create({
                withCredentials: true
            })
            instance.post(config.deleteDeliveryCart,paramsData).then(
                    function(response){
            // that.subp()

                        if(response.data.resultCode =="1"){
                            // that.subplan_num.splice(indexs.index,1)
                            // that.data2.splice(indexs.index,1)
                            // console.log(index)
                            // that.addnum3.splice(groupList,1)
                            that.opl()
                            // that.resgouwuche=that.resgouwuche-indexs.row.primaryQty
                            that.$Message.info(language.shanchuchenggong)
                        }
                    }
                )
            console.log(numberser)
        },
        resets(y){
            let that = this;
            let paramsData=new FormData();
            // let paramsData = new FormData();
            // that.newCardObj='';
            // console.log(that.newCardObj)
            // console.log(x)
            let numberser=new Array()
            for(var i=0;i<y[0].value.group.length;i++){
                // console.log(y[0].value.group[i].serialCode)
                numberser.push(y[0].value.group[i].serialCode)
            }
            console.log(numberser)
            paramsData.append("serialCode",numberser.toString());

            // paramsData.numberser=
            // paramsData=numberser.toString();
            // paramsData:
            // paramsData.push(numberser);
            // paramsData={
            //     "serialCode":numberser.toString()
            // }
            const instance = axios.create({
                withCredentials: true
            })
            instance.post(config.deleteDeliveryPlan,paramsData).then(
                    function(response){
            // that.subp()

                        if(response.data.resultCode =="1"){
                            // that.subplan_num.splice(indexs.index,1)
                            // that.data2.splice(indexs.index,1)
                            // console.log(index)
                            // that.addnum3.splice(groupList,1)
                            that.opl2()
                            // that.resgouwuche=that.resgouwuche-indexs.row.primaryQty
                            that.$Message.info(language.shanchuchenggong)
                        }
                    }
                )
        },
        selectType(){
            let that = this;
            axios.post(config.categoryCodeDrop,{}).then(function(response){
                // console.log(response.data.resultData)
                let resultData=response.data.resultData
                for(var i=0;i<resultData.length;i++){
                    if(resultData[i].categoryCode!=null){
                        that.selectDatta.push(resultData[i].categoryCode)
                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(that.selectDatta)
                }
            })
        },
        shopsignDrop(){
            let that = this;
            axios.post(config.shopsignDrop,{}).then(function(response){
                // console.log(1)
                // console.log(response.data.resultData)
                let resultDatas=response.data.resultData
                for(var i=0;i<resultDatas.length;i++){
                    if(resultDatas[i].shopsign!=null){
                    that.shopDatta.push(resultDatas[i].shopsign)

                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(that.shopDatta)
                }
            })
        },
        warehouseNameDrop(){
            let that = this
            axios.post(config.warehouseNameDrop,{}).then(function(response){
               let resultDatas=response.data.resultData
                for(var i=0;i<resultDatas.length;i++){
                    if(resultDatas[i].warehouseName!=null){
                    that.wareDatta.push(resultDatas[i].warehouseName)

                    }
                    // console.log(resultData[i].categoryCode)
                    // console.log(response)
                }
            })
        },
        ifpackage(){
            let that = this;
            // console.log(that.indexnum)
            let paramsData=[]
            let serialCodeparamas={}
            if(that.indexnum=='1'){
                if(that.subplan_num.length>0&&that.subplan_num.length!=null){
                for(var i=0;i<that.subplan_num.length;i++){
                    if(that.subplan_num[i].serialCode){
                        paramsData.push(that.subplan_num[i].serialCode);
                    }
            }
        }
                serialCodeparamas.serialCode = paramsData
            }else if(that.indexnum=='2'){
                for(var i=0;i<that.data2.length;i++){
                    if(that.data2[i].serialCode){
                        paramsData.push(that.data2[i].serialCode);
                    }
                }
                serialCodeparamas.serialCode = paramsData
            }else if(that.indexnum=='3'){
                console.log(that.data2)

                for(var i=0;i<that.data2.length;i++){
                if(that.data2[i].serialCode){
                    paramsData.push(that.data2[i].serialCode);
                }
            }
                serialCodeparamas.serialCode = paramsData
            }
            
            
            axios.post(config.packageTogether,serialCodeparamas).then(
                function(response){
                    if(response.status == 200){
                        if(response.data.resultCode==0){
                            // alert(25153)
                            that.$Message.info(response.data.resultMsgDetail); 
                    that.$Message.warning({
                            content: response.data.resultMsgDetail,
                            duration: 10,
                            // showTabSec : false
                })
                        



                            
                        }else if(response.data.resultCode==1){
                            that.storagess()

                        }
                    }else{
                        that.$Message.info(response.data.resultMsgDetail); 
                    }

                })
        },
        storagess(){
            let that = this;
            let paramsData=[]
            let serialCode={}
            if(that.indexnum=='1'){

                for(var i=0;i<that.subplan_num.length;i++){
                if(that.subplan_num[i].serialCode&&that.subplan_num!="undefined"){

                    paramsData.push(that.subplan_num[i].serialCode);
                }
            }
        }else if(that.indexnum=='2'){
            for(var i=0;i<that.data2.length;i++){
                if(that.data2[i].serialCode){
                    paramsData.push(that.data2[i].serialCode);
                }
            }
        }else if(that.indexnum=='3'){
            for(var i=0;i<that.data2.length;i++){
                if(that.data2[i].serialCode){
                    paramsData.push(that.data2[i].serialCode);
                }
            }
        }

        if(that.indexnum=='1'){
            that.showTabSec=true; 
            }
        else if(that.indexnum=='2'){
            that.showTab=true;
            }
        else if(that.indexnum=='3'){
            that.showTabs=true
            }
            //按需求去掉仓储逻辑判断
            // serialCode.serialCode = paramsData
            // axios.post(config.turnToWarehouse,serialCode).then(
            //     function(response){
            //         if(response.status == 200){
            //             if(response.data.resultCode == 0){
            //                 that.$Modal.confirm({
            //                 title: 'Title',
            //                 content: response.data.resultMsgDetail+language.shifoujixutijiao,
            //                 onOk: () => {
            //                     if(that.indexnum=='1'){
            //                     that.showTabSec=true; 

            //                 }
            //                 else if(that.indexnum=='2'){
            //                     that.showTab=true;
            //                 }
            //                 else if(that.indexnum=='3'){
            //                     that.showTabs=true
            //                 }
            //                 },
            //                 onCancel: () => {
            //                  // that.$Message.info(language.tihuoshenqingzhuliebiao)
            //                 }
            //             })
            //             }else if(response.data.resultCode == 1){
            //                 if(that.indexnum=='1'){
            //                     that.showTabSec=true; 

            //                 }
            //                 else if(that.indexnum=='2'){
            //                     that.showTab=true;
            //                 }
            //                 else if(that.indexnum=='3'){
            //                     that.showTabs=true
            //                 }
            //             }
            //         }else{
            //              that.$Message.info(response.data.resultMsgDetail); 
            //         }
            //     })
        },

        removeCarNews(index){
            let that = this;
            // that.packnum = index
            let paramsData = new FormData();
            paramsData.append("serialCode",index);
            const instance = axios.create({
                withCredentials: true
            })
            console.log(index);
            instance.post(config.deleteDeliveryCart,paramsData).then(
                    function(response){
            // that.subp()

                        if(response.data.resultCode =="1"){
                            // that.subplan_num.splice(indexs.index,1)
                            // that.data2.splice(indexs.index,1)
                            // console.log(index)
                            // that.addnum3.splice(groupList,1)
                            that.opl()
                            // that.resgouwuche=that.resgouwuche-indexs.row.primaryQty
                            that.$Message.info(language.shanchuchenggong)
                        }
                    }
                )
        },
        removeCarNewss(index){
            let that = this;
            let paramsData = new FormData();
            // console.log(111)
            paramsData.append("serialCode",index);
            // paramsData.serialCode=index;
            // console.log(paramsData)
            const instance = axios.create({
                withCredentials: true
            })
            instance.post(config.deleteDeliveryPlan,paramsData).then(
                    function(response){
            // that.subp()

                        if(response.data.resultCode =="1"){
                            // that.subplan_num.splice(indexs.index,1)
                            // that.data2.splice(indexs.index,1)
                            // console.log(index)
                            // that.addnum3.splice(groupList,1)
                            that.opl2()
                            // that.resgouwuche=that.resgouwuche-indexs.row.primaryQty
                            that.$Message.info(language.shanchuchenggong)
                        }
                    }
                )
        },
        getNews(params){
            let that = this;
            that.data2=params  
            console.log(params)            
            for(var i=0;i<params.length;i++){
                console.log(params[i].primaryQty)
                that.weightres+=parseInt(params[i].primaryQty)
            }
                console.log(that.weightres)

        },
        chongzhis(){
                let that = this;
                that.numpinzhong="";
                that.numpaihao="";
                that.numhou="";
                that.numchang="";
                that.numkuan="";
                that.numcangku="";
                that.numkunbaohao="";
                that.nummujuanhao="";

                that.cunhuo="";
                // that.cpyl="";
        },
        tiaozhuan(){
            this.$router.push({name: 'firstpage',params:{ id:'1'}});
        },

        chaxun(){
            let that = this;
            if(that.flag1==true){
                that.$Message.info(language.qingshaodeng)

                let params={};
                params.categoryCode = that.numpinzhong;
                params.shopsign = that.numpaihao;
                params.thickness = that.numhou;
                params.length = that.numchang;
                params.width = that.numkuan;
                params.warehouseName = that.numcangku;
                params.serialCode = that.numkunbaohao;
                params.reelNo = that.nummujuanhao;
                params.businessType = that.cunhuo;
                // params.stockType = that.cpyl;
                params.productMaterials="1"
                params.queryFlag="02"
                 axios.post(config.queryStockOnHand,params).then(function(response){
                if(response.data.resultCode==1){
                    that.numnum=response.data.page.totalPageCount
                    that.partproduct=response.data.resultData
                that.modal1=false
                }
            })
             }
             if(that.flag2==true){
                let params={};
                params.categoryCode = that.numpinzhong;
                // params.stockType = that.cpyl;
                params.shopsign = that.numpaihao;
                params.thickness = that.numhou;
                params.length = that.numchang;
                params.width = that.numkuan;
                params.warehouseName = that.numcangku;
                params.serialCode = that.numkunbaohao;
                params.reelNo = that.nummujuanhao;
                params.businessType = that.cunhuo;
                params.productMaterials="2"
                params.queryFlag="02"
                axios.post(config.queryStockOnHand,params).then(function(response){
                if(response.data.resultCode==1){
                    that.numnum=response.data.page.totalPageCount
                    that.materia=response.data.resultData
                that.modal1=false
                }
            })
             }
        },
        jiaohuodi(){
              let that = this;
                axios.post(config.placeofDelivery,{}).then(function(response){
                    if(response.data.resultCode  == 1){
                        let activeValues = response.data.resultData;
                        let arrNews= [];
                        for(let i =0 ;i <activeValues.length ;i++){
                            if( activeValues[i].tradeAddress!= null){
                                // if(activeValues[i].tradeAddress!=activeValues[i+1].tradeAddress){

                                let activeName = {
                                    value:activeValues[i].siteCode,
                                    label:activeValues[i].tradeAddress
                                }
                                arrNews.push(activeName)
                            // }
                                // console.log(activeValues[i].label)
                               
                            }else if(activeValues[i].tradeAddress== null||activeValues[i].tradeAddress==""){
                                let activeName = {
                                    value:activeValues[i].siteAlt,
                                    label:activeValues[i].siteAlt
                                }
                                arrNews.push(activeName)
                            }
                            // console.log()
                             
                        }
                        that.deliveryPlace = arrNews;
                    }
                })
        },
        jiaoHuoFangShi(){
                let that = this;
                axios.post(config.modeofDelivery,{}).then(function(response){
                    if(response.data.resultCode  == 1){
                        let activeValues = response.data.resultData;
                        let arrNews= [];
                        for(let i =0 ;i <activeValues.length ;i++){
                            let activeName = {
                                value:activeValues[i].itemCode,
                                label:activeValues[i].itemCname
                            }
                            arrNews.push(activeName)
                        }
                        // console.log(arrNews)
                        that.deliveryMethod = arrNews;
                    }
                })
        },
        fangshi(){
                let that = this;
                axios.post(config.settlementCurrency,{}).then(function(response){
                    if(response.data.resultCode  == 1){
                        let activeValues = response.data.resultData;
                        let arrNews= [];
                        for(let i =0 ;i <activeValues.length ;i++){
                            let activeName = {
                                value:activeValues[i].itemCode,
                                label:activeValues[i].itemCname
                            }
                            arrNews.push(activeName)
                        }
                        // console.log(arrNews)
                        that.settlementCurrency = arrNews;
                    }
                })
        },
        jiesuan(){
                let that = this;
                // this.subplanNumJihua[indexs.index].settlementUser = b;
                axios.post(config.queryClearinguser,{}).then(function(response){
                    if(response.data.resultCode  == 1){
                        let activeValues = response.data.resultData;
                        let arrNews= [];
                        for(let i =0 ;i <activeValues.length ;i++){
                            let activeName = {

                                value:activeValues[i].tuTradeUnitId,
                                label:activeValues[i].tuTradeUnitName
                            }
                            arrNews.push(activeName)
                        }
                        that.queryClearinguser = arrNews;
                    }
                })
        },
    	Tabswitch1(index){
    		let that = this;
            that.data2 = [];
    		if(that.flag1==false)
    		{
    			that.flag1=true;
    			that.flag2=false;
                that.BackCol=true;
                that.BackCol2=false;
    		}
            that.$Message.info({
                content:language.shujujiazaiqingshaodeng,
                duration: 100

            })
            let paramsData={
                "categoryCode" : that.numpinzhong,
                "shopsign" : that.numpaihao,
                "thickness" : that.numhou,
                "length" : that.numchang,
                "width" : that.numkuan,
                "warehouseName" : that.numcangku,
                "serialCode" : that.numkunbaohao,
                "productMaterials":"1",
                "queryFlag":"02",
            }
            // if(that.partproduct.length>0)return;
    		axios.post(config.queryStockOnHand,paramsData).then(function(response){
                if(response.data.resultCode==1){
                    console.log(response)
                    that.partproduct=response.data.resultData;

                    that.$Message.destroy()
                }
                
    		})
    		
        },
    	Tabswitch2(){
			let that = this;
            that.data2 = [];
    		if(that.flag2==false){
                  that.flag2=true;
                  that.flag1=false;
                  that.BackCol2=true;
                  that.BackCol=false;
    		}
            let paramsData={
                'categoryCode' : that.numpinzhong,
                'shopsign' : that.numpaihao,
                'thickness' : that.numhou,
                'length' : that.numchang,
                'width' : that.numkuan,
                'warehouseName' : that.numcangku,
                'serialCode' : that.numkunbaohao,
                'productMaterials':"2",
                'queryFlag':"02",
            }
            that.$Message.info({
                content:language.shujujiazaiqingshaodeng,
                duration: 100

            })
            // if(that.materia.length>0)return;
    		axios.post(config.queryStockOnHand,paramsData).then(function(response){
            if(response.data.resultCode==1){
            that.materia=response.data.resultData
            that.$Message.destroy()
            }
    		      })
		},
		subCat(index){
			let partproduct = this.partproduct;	
            let paramsData={
                "info": [{
				"warehouseName":partproduct[index.index].warehouseName,
				"matCategoryCode":partproduct[index.index].matCategoryCode,
				"matShopsign":partproduct[index.index].matShopsign,
				"matSpecification":partproduct[index.index].matSpecification,
				"categoryCode":partproduct[index.index].categoryCode,
				"shopsign":partproduct[index.index].shopsign,
				"specification":partproduct[index.index].specification,
				"thickness":partproduct[index.index].thickness,
				"width":partproduct[index.index].width,
				"length":partproduct[index.index].length,
				"primaryQty":partproduct[index.index].primaryQty,
				"serialCode":partproduct[index.index].serialCode,
				"reelNo":partproduct[index.index].reelNo,
				"exposedName":partproduct[index.index].exposedName,
				"rollPath":partproduct[index.index].rollPath,
				"storageCode":partproduct[index.index].storageCode,
				"stockInDate":partproduct[index.index].stockInDate,
				"extinstockType":partproduct[index.index].extinstockType,
				"businessType":partproduct[index.index].businessType,
				"contractNo":partproduct[index.index].contractNo,
				"templateCode":partproduct[index.index].templateCode,
				"tuTradeUnitId":partproduct[index.index].tuTradeUnitId,
				"tuTradeUnitName":partproduct[index.index].tuTradeUnitName,
				"customerId":partproduct[index.index].customerId,
				"customerName":partproduct[index.index].customerName,
                "templateSubid":partproduct[index.index].templateSubid,
                "stockType":partproduct[index.index].stockType,
                "rawPrimaryQty":partproduct[index.index].rawPrimaryQty,
                "rawPieceSpecdesc":partproduct[index.index].rawPieceSpecdesc,
                "settlementUser":partproduct[index.index].settlementUser,
                "settlementUserName":partproduct[index.index].settlementUserName,
                "settlementCurrency":partproduct[index.index].settlementCurrency,
                "settlementCurrencyName":partproduct[index.index].settlementCurrencyName,
                "deliveryMethod":partproduct[index.index].deliveryMethod,
                "deliveryMethodName":partproduct[index.index].deliveryMethodName,
                "width":partproduct[index.index].width,
                "thickness":partproduct[index.index].thickness,
                "secondQty":partproduct[index.index].secondQty,
                "locationName":partproduct[index.index].locationName,
          }]
                  }
                  let that =this;
			axios.post(config.addDeliveryCart,paramsData).then(function(response){
			if(response.data.resultCode=='1'){
                  that.opl();

                        that.$Message.info(language.caozuochenggong)
                        that.subplan_num.push(index.row)
                        // console.log(that.subplan_num)
                  }
                  else{
                        that.$Message.info(response.data.resultMsgDetail)
                  }
			}).then(
            )
		},

    	tiHuoplan(index){
    		let materia = this.materia;	
    		let paramsData={
                "info": [{
                "warehouseName":materia[index.index].warehouseName,
                "matCategoryCode":materia[index.index].matCategoryCode,
                "matShopsign":materia[index.index].matShopsign,
                "matSpecification":materia[index.index].matSpecification,
                "categoryCode":materia[index.index].categoryCode,
                "shopsign":materia[index.index].shopsign,
                "specification":materia[index.index].specification,
                "thickness":materia[index.index].thickness,
                "width":materia[index.index].width,
                "length":materia[index.index].length,
                "primaryQty":materia[index.index].primaryQty,
                "serialCode":materia[index.index].serialCode,
                "reelNo":materia[index.index].reelNo,
                "exposed":materia[index.index].exposed,
                "exposedName":materia[index.index].exposedName,
                "rollPath":materia[index.index].rollPath,
                "storageCode":materia[index.index].storageCode,
                "stockInDate":materia[index.index].stockInDate,
                "extinstockType":materia[index.index].extinstockType,
                "businessType":materia[index.index].businessType,
                "contractNo":materia[index.index].contractNo,
                "templateCode":materia[index.index].templateCode,
                "tuTradeUnitId":materia[index.index].tuTradeUnitId,
                "tuTradeUnitName":materia[index.index].tuTradeUnitName,
                "customerId":materia[index.index].customerId,
                "customerName":materia[index.index].customerName,
                "templateSubid":materia[index.index].templateSubid,
                "settlementUser":materia[index.index].settlementUser,
                // "<settlementUser></settlementUser>Name":materia[index.index].settlementUserName,
                "settlementCurrency":materia[index.index].settlementCurrency,
                "settlementCurrencyName":materia[index.index].settlementCurrencyName,
                "deliveryMethod":materia[index.index].deliveryMethod,
                "deliveryMethodName":materia[index.index].deliveryMethodName,
                "deliveryPlace":materia[index.index].deliveryPlace,
                "width":materia[index.index].width,
                "thickness":materia[index.index].thickness,
                "secondQty":materia[index.index].secondQty,
                "locationName":materia[index.index].locationName,
                "rawPrimaryQty":materia[index.index].rawPrimaryQty,
                "rawPieceSpecdesc":materia[index.index].rawPieceSpecdesc,

            }]
    		}
            let that = this
            if(index.row.templateCode!==null){
            // console.log(index.row)
            axios.post(config.addDeliveryPlan,paramsData).then(function(response){ 
                // console.log(index.row.templateCode)
                
                    if(response.data.resultCode=='1'){
                    // console.log(that.subplanNumJihua)
                    that.$Message.info(language.caozuochenggong)
            that.opl2();

                    that.subplanNumJihua.push(index.row)
                    that.resgouwuche2= 0;
                    }else{
                      that.$Message.info(response.data.resultMsgDetail)
                  }
              
			    
           
    	})}else{
                that.$Message.info(language.gaikunbaomeiyoumobanbunengtianjiajihua)
              }
    	},
        tijiao(index){
            let materia = this.materia; 
            let paramsData={
            "info": [{
            "warehouseName":materia[index.index].warehouseName,
            "matCategoryCode":materia[index.index].matCategoryCode,
            "matShopsign":materia[index.index].matShopsign,
            "matSpecification":materia[index.index].matSpecification,
            "categoryCode":materia[index.index].categoryCode,
            "shopsign":materia[index.index].shopsign,
            "specification":materia[index.index].specification,
            "thickness":materia[index.index].thickness,
            "width":materia[index.index].width,
            "length":materia[index.index].length,
            "primaryQty":materia[index.index].primaryQty,
            "serialCode":materia[index.index].serialCode,
            "reelNo":materia[index.index].reelNo,
            "exposed":materia[index.index].exposed,
            "rollPath":materia[index.index].rollPath,
            "storageCode":materia[index.index].storageCode,
            "stockInDate":materia[index.index].stockInDate,
            "extinstockType":materia[index.index].extinstockType,
            "businessType":materia[index.index].businessType,
            "contractNo":materia[index.index].contractNo,
            "templateCode":materia[index.index].templateCode,
            "tuTradeUnitId":materia[index.index].tuTradeUnitId,
            "tuTradeUnitName":materia[index.index].tuTradeUnitName,
            "customerId":materia[index.index].customerId,
            "customerName":materia[index.index].customerName,
            "templateSubid":materia[index.index].templateSubid,
            "settlementUser":materia[index.index].settlementUser,
            "settlementUserName":materia[index.index].settlementUserName,
            "settlementCurrency":materia[index.index].settlementCurrency,
            "settlementCurrencyName":materia[index.index].settlementCurrencyName,
            "deliveryMethod":materia[index.index].deliveryMethod,
            "deliveryMethodName":materia[index.index].deliveryMethodName,
            "deliveryPlace":materia[index.index].deliveryPlace,
            "stockType":materia[index.index].stockType,
            "rawPrimaryQty":materia[index.index].rawPrimaryQty,
            "rawPieceSpecdesc":materia[index.index].rawPieceSpecdesc,
            "exposedName":materia[index.index].exposedName,
                "secondQty":materia[index.index].secondQty,
                "locationName":materia[index.index].locationName,

            }]
            }
            let that = this
            axios.post(config.addDeliveryCart,paramsData).then(function(response){ 
            if(index.row.templateCode!=null || index.row.templateCode!='' || index.row.templateCode!='null'){
              if(response.data.resultCode=='1'){
                that.opl();

                    that.$Message.info(language.caozuochenggong)
                    that.subplan_num.push(index.row)
                    that.resgouwuche2=0;
              }else{
                    that.$Message.info(response.data.resultMsgDetail)
              }
        }
        })
        },
    		// 购物车
    	subplan_list_lit(){
    		let that = this
			if(that.sub_lit==false){
				that.sub_lit=true;
				that.sub_lit2=false;
                that.opl();
            }
                
			else{
				that.sub_lit=false
				that.sub_lit2=false
			}
	   },
        opl(){
            let that = this;
            axios.post(config.queryDeliveryCarts).then(function(response){
                        if(response.data.resultCode == 1){
                            let groupList = [];
                            let groupLists = '';
                            // var j
                            that.addnum = groupList;
                            that.addnum2 = response.data.resultData;
                            that.newCardObj = [];
                            // if( that.addnum2.length>0){
                                for(var i in that.addnum2){
                                    groupLists=i
                                    if(typeof that.addnum2[groupLists] == 'object'){
                                        let key ={};
                                        that.$set(key,'key',groupLists)
                                        that.$set(key,'value',that.addnum2[groupLists])
                                        that.newCardObj.push(key)
                                    }
                                    // for(var )
                                }
                            // }

                        }
                })
        },
        opl2(){
             let that = this;
            axios.post(config.queryDeliveryPlans).then(function(response){
                        let groupListdd = [];
                        let groupListsdd = '';
                        // for(var i=0;i<response.data.resultData.BGM.group.length;i++){
                        //     groupListdd.push(response.data.resultData.BGM.group[i])
                        // }
                        if(response.data.resultCode == 1){
                        // for(j in that.addnum3.group){}
                        that.addnum = groupListdd;
                        that.addnum3 = response.data.resultData;
                        that.newCardObj2 = [];
                        for(var i in that.addnum3){
                            groupListsdd=i
                            if(typeof that.addnum3[groupListsdd] == 'object'){
                                let key ={};
                                // key.push(newObj)
                                that.$set(key,'key',groupListsdd)
                                that.$set(key,'value',that.addnum3[groupListsdd])
                                that.newCardObj2.push(key)
                            }
                            // for(var )
                        }
                    }
                        // that.keys=key[0]
                        // if(typeof res)
                })
        },
		// 提货计划
		tihuoJihua(){
			let that = this;
			if(that.sub_lit2==false){
					that.sub_lit2=true
					that.sub_lit=false
                    that.opl2()
		      }
                   else{
					that.sub_lit2=false
					that.sub_lit=false
			}
		},
        // 提货计划交货期
        dataChange(indexs,val){
              // this.subplanNumJihua[indexs.index].deliveryDate = val;
              if(this.subplanNumJihua.length>1){
              // this.subplanNumJihua[indexs.index].deliveryDate = val;
              for(var i=0;i<this.subplanNumJihua.length;i++){
                console.log(this.subplanNumJihua)
                console.log(this.subplanNumJihua[i].deliveryDate)
                this.subplanNumJihua[i].deliveryDate=val;

              }
            }
        },
        // dataChanges(indexs,val){
        //       this.data3[indexs.index].deliveryDate = val;
        // },
        dataChanged(indexs,val){
            // console.log(indexs,val)
            if(this.subplan_num.length>1){
              // this.subplan_num[indexs.index].deliveryDate = val;
              for(var i=0;i<this.subplan_num.length;i++){
                console.log(this.subplan_num)
                console.log(this.subplan_num[i].deliveryDate)
                this.subplan_num[i].deliveryDate=val;

              }
            }
            
        },
        dataChangeds(indexs,val){
              // this.data2[indexs.index].deliveryDate = val;
              if(this.data2.length>1){
              this.data2[indexs.index].deliveryDate = val;
              for(var i=0;i<this.data2.length;i++){
                console.log(this.data2)
                console.log(this.data2[i].deliveryDate)
                this.data2[i].deliveryDate=val;

              }
            }
        },
        // 提交提货计划
        tjthsqanspa(){
                let that = this;
                let datapop = {};
                datapop.deliveryShopCartList = that.subplanNumJihua;
                // datapop.templateSubid = that.materia.templateSubid;
                axios.post(config.submitDeliveryPlanApply,datapop).then(function(response){
                  that.$Message.info(response.data.fsuffix)
                  if(response.data.resultCode=="1"){
                      that.subplanNumJihua=[]
                      that.data2=[]
                    that.$Modal.confirm({
                        // title: '提示',
                        content: language.bencitihuoshenqingyitijiaoshifoujixutihuo,
                        onCancel: () => {
                            that.$Message.info(language.jinrutihuoshenqingliebiao);
                            that.$router.push({name: 'ladingsee',params:{ id:'1'}});
                        },
                         onOk:() => {
                        that.Tabswitch2()
                            
                            that.$Message.info(language.fanhuitihuoshenqingliebiao);
                            that.showTabSectim=false
                        }
                    });
                      }else{

                      }
              })
        },
        // gouwuchequanbu(){
        //       let that = this;
        //       let datanum = {};
        //       datanum.carNo = that.chepaihao;
        //       datanum.carrier = that.chengyunshang;
        //       datanum.remark = that.beizhu;
        //       datanum.deliveryShopCartList = that.data2;

        //       // datanum.deliveryShopCartList = that.data2;
        //       axios.post(config.submitDeliveryCartApply,datanum).then(function(response){
        //         if(response.data.resultCode=='1'){
        //             that.data2=""
        //             that.$Message.info(response.data.fsuffix)
        //           that.$Modal.confirm({
        //             title: '提示',
        //             content: '本次提货申请已提交，是否继续提货',

        //             onCancel: () => {
        //                 that.$Message.info('进入提货申请列表');
        //                 that.$router.push({name: 'ladingsee',params:{ id:'1'}});
        //             that.Tabswitch2()

        //             },
        //              onOk:() => {
        //                 that.$Message.info('返回提货申请列表');
        //                 that.showTab=false
        //                 that.showTabs=false
        //             }
        //         });
        //       }else{
        //         that.$Message.info(response.data.fsuffix);
        //       }
        //       })
        // },
         gouwuchequanbus(){
              let that = this;
              // for(let i=0;i<that.data1.length;i++){
              //   console.log(that.data1[i].settlementUserName)
              //   var cust=[]

              //   cust.append(that.data1[i].settlementUserName)
              // }
              // console.log(cust)
                var cust=[]
              that.data1.forEach(r=>{
                // params.row.contractNo||params.row.businessType=='CCIN'||params.row.businessType=='LLIN'
              if(!r.contractNo&&r.businessType!='CCIN'&&r.businessType!='LLIN'){
                console.log(r.contractNo,r.businessType,r.businessType)
                if(r.settlementUserName!=null){
                cust.push(r.settlementUserName)
                }


              }

                // console.log(that.data1.r)
                // console.log(r)
                if(r.templateCode&&r.templateSubid){
                    cust=[]
                    // console.log("cust"+cust)
                }
                return
              })
              // console.log(r)
              if(cust!=""){
                console.log(cust)
                    that.$Modal.confirm({
                    // title:"提示",
                        content:language.dangqianxuanzedejiesuanyonghuwei+"&nbsp"+cust+language.shifoujixutijiao,
                        onOk:() => {
                        let datanum = {};
                        datanum.carNo = that.chepaihao;
                        datanum.carrier = that.chengyunshang;
                        datanum.remark = that.beizhu;
                        datanum.deliveryShopCartList = that.data1;
                        // datanum.deliveryShopCartList = that.data2;
                        axios.post(config.submitDeliveryCartApply,datanum).then(function(response){
                        if(response.data.resultCode==1&&that.showTabSec==true){
                        that.data1=[];
                        // that.$Message.info(response.data.fsuffix)
                        // 
                        // if(that.showTabSec!=false){
                        that.$Modal.confirm({
                        // title: '提示',
                        content: language.bencitihuoshenqingyitijiaoshifoujixutihuo,
                        onCancel: () => {
                        that.$router.push({name: 'ladingsee',params:{ id:'1'}});

                        },
                        onOk:() => {
                        that.$Message.info(language.fanhuitihuoshenqingliebiao);
                        that.showTabSec=false
                        that.Tabswitch1()
                        }
                        });
                        }else{
                        that.$Message.info(response.data.fsuffix);
                        }
                        })
                        },
                        onCancel:()=>{
                        return
                        }


                    })
            }else if(cust==""){
                // alert(111)
                // that.$Modal.confirm({
                    // title:"提示",
                        // content:language.dangqianxuanzedejiesuanyonghuwei+"&nbsp"+cust+language.shifoujixutijiao,
                        // onOk:() => {
                        let datanum = {};
                        datanum.carNo = that.chepaihao;
                        datanum.carrier = that.chengyunshang;
                        datanum.remark = that.beizhu;
                        datanum.deliveryShopCartList = that.data1;
                        // datanum.deliveryShopCartList = that.data2;
                        axios.post(config.submitDeliveryCartApply,datanum).then(function(response){
                        if(response.data.resultCode==1&&that.showTabSec==true){
                        that.data1=[];
                        // that.$Message.info(response.data.fsuffix)
                        // 
                        // if(that.showTabSec!=false){
                        that.$Modal.confirm({
                        // title: '提示',
                        content: language.bencitihuoshenqingyitijiaoshifoujixutihuo,
                        onCancel: () => {
                        that.$router.push({name: 'ladingsee',params:{ id:'1'}});

                        },
                        onOk:() => {
                        that.$Message.info(language.fanhuitihuoshenqingliebiao);
                        that.showTabSec=false
                        that.Tabswitch1()
                        }
                        });
                        }else{
                        that.$Message.info(response.data.fsuffix);
                        }
                        })
                        // },
                        // onCancel:()=>{
                        // return
                        // }


                    // })
            }
              
                console.log(that.data1)

              
        },
        // gouwuchequanbus(){
        //       let that = this;
        //       let datanum = {};
        //       datanum.carNo = that.chepaihao;
        //       datanum.carrier = that.chengyunshang;
        //       datanum.remark = that.beizhu;
        //       // datanum.deliveryShopCartList = that.subplan_num;
        //       datanum.deliveryShopCartList = that.data2;
        //       axios.post(config.submitDeliveryCartApply,datanum).then(function(response){
        //           that.$Message.info(response.data.fsuffix)
        //       })
        // },
		removeCar(indexs){
			let that = this;
            let paramsData = new FormData();
            console.log(indexs.row.serialCode);
            paramsData.append("serialCode",indexs.row.serialCode);
            const instance = axios.create({
                withCredentials: true
            })
			instance.post(config.deleteDeliveryCart,paramsData).then(
					function(response){
            // that.subp()

						if(response.data.resultCode =="1"){
                            that.opl()
                            that.subplan_num.splice(indexs.index,1)
							that.data2.splice(indexs.index,1)
                            // console.log(that.data1[params.index])
                            // that.addnum3.splice(groupList,1)
                            // that.opl()
                            // that.resgouwuche=that.resgouwuche-indexs.row.primaryQty
                            that.$Message.info(language.shanchuchenggong)
						}
					}
				)
		},
		removeTihuo(indexs){
			let that = this;
			let paramsData = new FormData();
            paramsData.append("serialCode",indexs.row.serialCode);
            const instance = axios.create({
                withCredentials: true
            })
			instance.post(config.deleteDeliveryPlan,paramsData).then(
					function(response){
						if(response.data.resultCode =="1"){
                            that.subplanNumJihua.splice(indexs.index,1)
                            that.$Message.info(language.shanchuchenggong)
                            that.opl2()
						}
					}
				)
		},
        // removeTihuos(indexs){
        //       let that = this;
        //       let paramsData = new FormData();
        //       paramsData.append("serialCode",indexs.row.serialCode);
        //       axios.post(config.deleteDeliveryPlan,paramsData).then(
        //             function(response){
        //                   if(response.data.resultCode =="1"){
        //                       that.data3.splice(indexs.index,1)
        //                       that.$Message.info('删除成功')
        //                   }
        //             }
        //       )
        // },
		addTitleshow(index){
            if(this.showTabSec==false){
            let that = this;
            that.indexnum=index
            console.log(that.indexnum)
            // that.showTabSec=true;
            that.ifpackage();

            axios.post(config.queryDeliveryCart).then(function(response){
                that.subplan_num = response.data.resultData
                that.data1=response.data.resultData;
                console.log(that.data1)
            // that.storagess();
            that.sub_lit=false;
                if(that.data1.length>0&&that.data1.length!=null){
                  function AddDays(dayIn) {
                      let date=new Date();
                      let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
                      let year=myDate.getFullYear();
                      let month=myDate.getMonth()+1;
                      let day=myDate.getDate();
                      let CurrentDate=year+"-";
                      if(month>=10){
                        CurrentDate=CurrentDate+month+"-";
                      }else{
                        CurrentDate=CurrentDate+"0"+month+"-";
                      }
                      if(day>=10){
                        CurrentDate=CurrentDate+day;
                      }else{
                        CurrentDate=CurrentDate+"0"+day;
                      }
                      return CurrentDate;
                    }
                    let moRenDate = AddDays(1);
                    for(let i=0 ;i<that.data1.length;i++){
                            that.data1[i].deliveryDate = moRenDate;

                        if(!that.data1[i].contractNo&&that.data1[i].businessType!='CCIN'&&(!that.data1[i].templateCode||!that.data1[i].templateSubid)){
                            console.log(that.queryClearinguser)
                            if(that.queryClearinguser){


                            for(let j=0;j<that.queryClearinguser.length;j++){

                                if(that.queryClearinguser[j].value=="461"){
                                    that.data1[i].settlementUser=that.queryClearinguser[j].value;
                                    that.data1[i].settlementUserName=that.queryClearinguser[j].label;
                                }
                            }
                            }
                            
                            that.data1[i].settlementCurrency=that.settlementCurrency[1].value;
                            that.data1[i].settlementCurrencyName=that.settlementCurrency[0].label;
                            that.data1[i].deliveryMethod=that.deliveryMethod[0].value;
                            that.data1[i].deliveryMethodName=that.deliveryMethod[0].label;

                            that.data1[i].deliveryPlaceName=that.deliveryPlace[0].value;
                            that.data1[i].deliveryPlace=that.deliveryPlace[0].label;
                        }

                       
                    }
                    }
            })
            }else{
              this.showTabSec=false
            }
		},
        // addTitles(){
        //     // alert(111)
        //     let that = this
        //       if(that.flag1==true&&that.showTab==false){
        //           // that.showTab=true;
        //           that.sub_lit=false;
        //           that.showTabs=false;
        //     that.ifpackage();
        //           that.indexnum=2
        //           // console.log(that.indexnum)
        //           // that.ifpackagea();
        //             // that.ifpackage();

        //         if(that.data2.length>0){
        //             function AddDays(dayIn) {
        //                 let date=new Date();
        //                 let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
        //                 let year=myDate.getFullYear();
        //                 let month=myDate.getMonth()+1;
        //                 let day=myDate.getDate();
        //                 let CurrentDate=year+"-";
        //             if(month>=10){
        //                 CurrentDate=CurrentDate+month+"-";
        //             }else{
        //                 CurrentDate=CurrentDate+"0"+month+"-";
        //             }
        //             if(day>=10){
        //                 CurrentDate=CurrentDate+day;
        //             }else{
        //                 CurrentDate=CurrentDate+"0"+day;
        //             }
        //                 return CurrentDate;
        //             }
        //             let moRenDate = AddDays(1);

        //             for(let i=0 ;i<that.data2.length;i++){
        //              that.data2[i].deliveryDate = moRenDate;

        //                  if(!that.data2[i].contractNo&&that.data2[i].businessType!='CCIN'&&(!that.data2[i].templateCode||!that.data2[i].templateSubid)){
        //                     that.data2[i].settlementUser=that.queryClearinguser[0].value;
        //                     that.data2[i].settlementCurrency=that.settlementCurrency[0].value;
        //                     that.data2[i].deliveryMethod=that.deliveryMethod[0].value;
        //                     that.data2[i].deliveryPlace=that.deliveryPlace[0].value;
        //                  }
                        
        //             }
        //         }
        //         }else{
        //           that.showTab=false
        //         }
        //         if(that.flag2==true&&that.showTabs==false){
        //             // that.showTabs=true;
        //             that.showTab=false;
        //             that.sub_lit=false;
        //             that.indexnum=3
        //             that.ifpackage();
        //             if(that.data2.length>0){
        //             function AddDays(dayIn) {
        //                 let date=new Date();
        //                 let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
        //                 let year=myDate.getFullYear();
        //                 let month=myDate.getMonth()+1;
        //                 let day=myDate.getDate();
        //                 let CurrentDate=year+"-";
        //             if(month>=10){
        //                 CurrentDate=CurrentDate+month+"-";
        //             }else{
        //                 CurrentDate=CurrentDate+"0"+month+"-";
        //             }
        //             if(day>=10){
        //                 CurrentDate=CurrentDate+day;
        //             }else{
        //                 CurrentDate=CurrentDate+"0"+day;
        //             }
        //                 return CurrentDate;
        //             }
        //             let moRenDate = AddDays(1);

        //             for(let i=0 ;i<that.data2.length;i++){
        //                     that.data2[i].deliveryDate = moRenDate;

        //                 if(!that.data2[i].contractNo&&that.data2[i].businessType!='CCIN'&&(!that.data2[i].templateCode||!that.data2[i].templateSubid)){

        //                     that.data2[i].settlementUser=that.queryClearinguser[0].value;
        //                     that.data2[i].settlementCurrency=that.settlementCurrency[0].value;
        //                     that.data2[i].deliveryMethod=that.deliveryMethod[0].value;
        //                     that.data2[i].deliveryPlace=that.deliveryPlace[0].value;
        //                 }
                        
        //             }
        //         }

        //         }else{
        //             that.showTabs=false
        //         }
        // },
		addTit(){
			let that = this 
			if(that.showTabSectim==false){
				that.showTabSectim=true;
                axios.get(config.queryDeliveryPlan).then(function(response){
                    // if(response.data.resultData!=""){

                    that.subplanNumJihua=response.data.resultData;
                    if(that.subplanNumJihua.length>0){
                    function AddDays(dayIn) {
                        // that.ifpackaged();
                        // that.storagessd();
                        let date=new Date();
                        let myDate=new Date(date.getTime()+dayIn*24*60*60*1000);
                        let year=myDate.getFullYear();
                        let month=myDate.getMonth()+1;
                        let day=myDate.getDate();
                        let CurrentDate=year+"-";
                        if(month>=10){
                            CurrentDate=CurrentDate+month+"-";
                        }else{
                            CurrentDate=CurrentDate+"0"+month+"-";
                        }
                        if(day>=10){
                            CurrentDate=CurrentDate+day;
                        }else{
                            CurrentDate=CurrentDate+"0"+day;
                        }
                        return CurrentDate;
                            }
                            let moRenDate = AddDays(1);
                                for(let i=0 ;i<that.subplanNumJihua.length;i++){
                                  that.subplanNumJihua[i].deliveryDate = moRenDate;
                                }
                    }
                    for(var i=0; i<response.data.resultData.length;i++){
                        that.resgouwuche2+=parseInt(response.data.resultData[i].primaryQty)
                    }
                // }
                })
                        this.sub_lit2=false
			}else{
				that.showTabSectim=false
			}
		},
        riqi(){
            var myDate = new Date();    
            var year = myDate.getFullYear();    //获取完整的年份(4位,1970-????)
            var month = myDate.getMonth()+1;       //获取当前月份(1-12)
            var day = myDate.getDate();        //获取当前日(1-31)
            //获取完整年月日
            // let that=this
            this.newDate = year + "-" + month + "-" + day;
        },
    	fanhui(){
    		this.showTabSec=false
            this.showTabSectim=false
    		this.showTab=false
            this.showTabs=false
    	},
    },
mounted(){
    this.languages = language
	this.Tabswitch1();
    this.jiesuan();
    this.fangshi();
    this.jiaoHuoFangShi();
    this.jiaohuodi();
    this.riqi();
    this.selectType();
    this.shopsignDrop();
    this.warehouseNameDrop();

    // this.subp();
	}
		
}
</script>


// WEBPACK FOOTER //
// delivery.vue?29de5700